"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parentToArea = exports.toArea = exports.toAreaId = exports.Area = void 0;
var Area;
(function (Area) {
    Area[Area["HONG_KONG_ISLAND"] = 0] = "HONG_KONG_ISLAND";
    Area[Area["KOWLOON"] = 1] = "KOWLOON";
    Area[Area["NEW_TERRITORIES"] = 2] = "NEW_TERRITORIES";
    Area[Area["OUTLYING_ISLANDS"] = 3] = "OUTLYING_ISLANDS";
})(Area = exports.Area || (exports.Area = {}));
exports.toAreaId = function (area) {
    if (area === Area.HONG_KONG_ISLAND)
        return 1;
    if (area === Area.KOWLOON)
        return 2;
    if (area === Area.NEW_TERRITORIES)
        return 3;
    if (area === Area.OUTLYING_ISLANDS)
        return 4;
    return 1;
};
exports.toArea = function (id) {
    if (id === 1)
        return Area.HONG_KONG_ISLAND;
    if (id === 2)
        return Area.KOWLOON;
    if (id === 3)
        return Area.NEW_TERRITORIES;
    if (id === 4)
        return Area.OUTLYING_ISLANDS;
    return Area.HONG_KONG_ISLAND;
};
exports.parentToArea = function (id) {
    if (id === 1000)
        return Area.HONG_KONG_ISLAND;
    if (id === 2000)
        return Area.KOWLOON;
    if (id === 3000)
        return Area.NEW_TERRITORIES;
    if (id === 4000)
        return Area.OUTLYING_ISLANDS;
    return Area.HONG_KONG_ISLAND;
};
